import * as React from "react";
import {option} from "ts-option";
import {InlineFormGroupProps} from "../../common/props/FormGroupProps";
import ButtonGroup from "../../../hiberUiKit/src/atoms/ButtonGroup/ButtonGroup";
import ButtonPrimary from "../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import ButtonSecondary from "../../../hiberUiKit/src/atoms/Buttons/ButtonSecondary";
import {QuotePartsPriceStrategy} from "../../../model/quote/Quote";

interface IProps {
	/**
	 * Custom class name.
	 */
	customClass?: string;
}

type Props = IProps & InlineFormGroupProps<string>;

export default class PriceStrategyFormGroup extends React.Component<Props, {}> {

	render() {
		return (
			<ButtonGroup customClass={this.props.customClass}>
				{this.renderButtons()}
			</ButtonGroup>
		)
	}

	renderButtons() {
		if (this.props.field.getValue() === QuotePartsPriceStrategy.BEST_AVAILABILITY) {
			return (
				<>
					<ButtonPrimary label={"Best availability"}
								   onClick={() => this.updateValue(QuotePartsPriceStrategy.BEST_AVAILABILITY)}/>
					<ButtonSecondary label={"Lowest price"}
									 onClick={() => this.updateValue(QuotePartsPriceStrategy.LOWER_PRICE)}/>
				</>
			)
		}
		return (
			<>
				<ButtonSecondary label={"Best availability"}
								 onClick={() => this.updateValue(QuotePartsPriceStrategy.BEST_AVAILABILITY)}/>
				<ButtonPrimary label={"Lowest price"}
							   onClick={() => this.updateValue(QuotePartsPriceStrategy.LOWER_PRICE)}/>
			</>
		)
	}

	updateValue(newStrategy: QuotePartsPriceStrategy) {
		if (this.props.field.getValue() != newStrategy) {
			this.props.onChange(this.props.field.updateValue(option(newStrategy)));
		}
	}
}
